import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AssignReportConfigurationMutationVariables = Types.Exact<{
  input: Types.AssignReportConfigurationInput;
}>;


export type AssignReportConfigurationMutation = { __typename?: 'Mutation', assignReportConfiguration: { __typename?: 'AssignReportConfigurationPayload', user?: Array<{ __typename?: 'User', id: string }> | null } };

export type GetAllKeywordVexExportConfigUsersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllKeywordVexExportConfigUsersQuery = { __typename?: 'Query', allKeywordVexExportConfigUsers: Array<{ __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }> };


export const AssignReportConfigurationDocument = gql`
    mutation AssignReportConfiguration($input: AssignReportConfigurationInput!) {
  assignReportConfiguration(input: $input) {
    user {
      id
    }
  }
}
    `;
export type AssignReportConfigurationMutationFn = Apollo.MutationFunction<AssignReportConfigurationMutation, AssignReportConfigurationMutationVariables>;

/**
 * __useAssignReportConfigurationMutation__
 *
 * To run a mutation, you first call `useAssignReportConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignReportConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignReportConfigurationMutation, { data, loading, error }] = useAssignReportConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignReportConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<AssignReportConfigurationMutation, AssignReportConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignReportConfigurationMutation, AssignReportConfigurationMutationVariables>(AssignReportConfigurationDocument, options);
      }
export type AssignReportConfigurationMutationHookResult = ReturnType<typeof useAssignReportConfigurationMutation>;
export type AssignReportConfigurationMutationResult = Apollo.MutationResult<AssignReportConfigurationMutation>;
export type AssignReportConfigurationMutationOptions = Apollo.BaseMutationOptions<AssignReportConfigurationMutation, AssignReportConfigurationMutationVariables>;
export const GetAllKeywordVexExportConfigUsersDocument = gql`
    query GetAllKeywordVexExportConfigUsers {
  allKeywordVexExportConfigUsers {
    givenName
    id
    mail
    name
    surname
    userPrincipalName
  }
}
    `;

/**
 * __useGetAllKeywordVexExportConfigUsersQuery__
 *
 * To run a query within a React component, call `useGetAllKeywordVexExportConfigUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllKeywordVexExportConfigUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllKeywordVexExportConfigUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllKeywordVexExportConfigUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllKeywordVexExportConfigUsersQuery, GetAllKeywordVexExportConfigUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllKeywordVexExportConfigUsersQuery, GetAllKeywordVexExportConfigUsersQueryVariables>(GetAllKeywordVexExportConfigUsersDocument, options);
      }
export function useGetAllKeywordVexExportConfigUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllKeywordVexExportConfigUsersQuery, GetAllKeywordVexExportConfigUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllKeywordVexExportConfigUsersQuery, GetAllKeywordVexExportConfigUsersQueryVariables>(GetAllKeywordVexExportConfigUsersDocument, options);
        }
export type GetAllKeywordVexExportConfigUsersQueryHookResult = ReturnType<typeof useGetAllKeywordVexExportConfigUsersQuery>;
export type GetAllKeywordVexExportConfigUsersLazyQueryHookResult = ReturnType<typeof useGetAllKeywordVexExportConfigUsersLazyQuery>;
export type GetAllKeywordVexExportConfigUsersQueryResult = Apollo.QueryResult<GetAllKeywordVexExportConfigUsersQuery, GetAllKeywordVexExportConfigUsersQueryVariables>;